/* Fix empty select2 after clicking "back" in browser */
$("#location").each(function () {
    $(this).val($(this).find('option[selected]').val());
});
var widget_generator = new AnalogWidgetGenerator({
    'suggest_url' : '/free-clocks/suggest-v2'
});
widget_generator.setup();
